module.exports = __webpack_public_path__ + "img/symbol_7.2ec8d298.png";